import React from 'react';
import PropTypes from 'prop-types';
import StoryboardBranding from 'storyboard/components/storyboard-branding';
import StoryboardLogo from 'storyboard/components/storyboard-logo';
import {getColorBasedOnContrast} from 'common/utils/color-util';
import {getLinearGradient} from 'common/utils/style-util';
import './index.scss';

export default class StoryboardLogoBar extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    openModal: PropTypes.func,
  };

  static defaultProps = {
    openModal: () => {},
  };

  getBrandingColor(configuration) {
    if (configuration && configuration.theme) {
      return getColorBasedOnContrast(configuration.theme.logoBarColors[0]);
    }
    return null;
  }

  render() {
    const {configuration} = this.props.data;
    const {superpartnerFooterLogo} = configuration;
    const brandingColor = this.getBrandingColor(configuration);
    return (
      <div
        className={'StoryboardLogoBar'}
        style={{
          background: getLinearGradient(configuration.theme.logoBarColors),
        }}>
        <StoryboardBranding
          color={brandingColor}
          superpartnerFooterLogo={superpartnerFooterLogo}
        />
        <StoryboardLogo
          data={this.props.data}
          openModal={this.props.openModal}
          superpartnerFooterLogo={superpartnerFooterLogo}
        />
      </div>
    );
  }
}
